import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import Avatar from 'components/Avatar';
import App from 'modules/App';
import { REMOVE_PATIENT_FORM } from '../../constants';
import styles from '../ModalCommon.pcss';
const Person = ()=>{
    const formValues = useSelector(App.selectors.formSelector(REMOVE_PATIENT_FORM));
    const patient = formValues && formValues.contextData || {};
    const { avatar, firstName, lastName } = patient;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('row align-items-center', styles.person),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-auto pr-0",
                children: /*#__PURE__*/ _jsx(Avatar, {
                    avatarImg: avatar,
                    name: [
                        firstName,
                        lastName
                    ],
                    className: styles.item__avatar,
                    imgClassName: styles.item__avatar__img,
                    initialsClassName: styles.item__avatar__initials
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col",
                children: /*#__PURE__*/ _jsxs("p", {
                    className: styles.person__name,
                    children: [
                        firstName,
                        " ",
                        lastName
                    ]
                })
            })
        ]
    });
};
export default Person;
